module.exports = __webpack_public_path__ + "media/images/faq-bg-f296698023e0464c5cbfb1c18e607d9e.png";